import { useEffect } from "react";

export function useGlobalKey(key: string, handler: (e: KeyboardEvent) => void) {
    useEffect(() => {
        const listener = (e: KeyboardEvent) => {
            const pressed = (e?.key ?? "").toLowerCase();
            if (pressed && pressed === key.toLowerCase()) {
                handler(e);
            }
        };

        window.addEventListener('keydown', listener);
        return () => window.removeEventListener('keydown', listener);
    }, [key, handler]);
}